import Vue from 'vue'
import {
	getOrderuserRule
} from '@/api/index'
export default {
	async install() {
		Vue.directive('has', {
			inserted: function(el, binding) {
				let value = binding.value;
				let hasPermission = localStorage.getItem('includeList').includes(value)
				if (localStorage.getItem('includeList').length != 0) {
					if (!hasPermission) {
						el.style = 'display:none';
						setTimeout(() => {
							el.parentNode.removeChild(el);
						}, 0)
					}
				}
			}
		})
	}
}